<!-- =========================================================================================
    File Name: ServerMonitoringEmail.vue
    Description: ServerMonitoringEmail Page
========================================================================================== -->

<template>
  <div>
    <email-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/>
    <p class="text-danger font-bold"> 
      <feather-icon icon="HashIcon" svgClasses="w-5 h-5" class="edit-icon text-danger font-bold" />
      {{this.$t('NOTI_EMAIL')}}
    </p>
    <p class="text-danger font-bold"> 
      <feather-icon icon="HashIcon" svgClasses="w-5 h-5" class="edit-icon text-danger font-bold" />
      {{this.$t('NOTI_UTC')}}
    </p>
     <p class="text-danger font-bold mb-5"> 
      <feather-icon icon="HashIcon" svgClasses="w-5 h-5" class="edit-icon text-danger font-bold" />
      {{this.$t('NOTI_TIME')}}
    </p>

    
    <vx-card class="overflow-auto">
        <vs-button v-if="onlyAdmin" class="bg-primary-gradient" icon-pack="feather" icon="icon-edit" @click="addNewData">{{this.$t('COMPOSE')}}</vs-button>
        <v-server-table id="notiemail-table" ref="notiEmailTable" name="notiEmailTables"
            :columns="getColumn" :options="options" @loading="onLoading" @loaded="onLoaded">
          <vs-chip slot="sendStatus" slot-scope="props" :color="getSendStatusColor(props.row.sendStatus)" class="w-full">
            {{$t(setSendStatusName(props.row.sendStatus))}}</vs-chip>

          <vs-chip slot="sendTarget" slot-scope="props" :color="getSendTargetColor(props.row.sendTarget)" class="w-full">
            {{$t(setSendTargetName(props.row.sendTarget))}}</vs-chip>

          <vs-chip slot="sendResult" slot-scope="props" :color="getSendResultColor(props.row.sendResult)" class="w-full">
            {{$t(setSendResultName(props.row.sendResult))}}</vs-chip>

          <vs-button slot="mailBody" slot-scope="props" color="primary" type="flat" @click="notiEmailBodyPopup(props.row)"  class="w-full">
           {{$t('SHOW_EMAIL_BODY')}}</vs-button>

           <div slot="sendCount" slot-scope="props" id="send-count">
             {{props.row.sendCount}}
          </div> 

           <div slot="edit" slot-scope="props">
             <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  @click.stop="checkEdit(props.row)" />
          </div> 
        </v-server-table>
    </vx-card>

    <vs-popup class="notice-body-popup"  :title="this.mailTitle" :active.sync="notiEmailPopupActive">
        <span v-html="this.mailBody.replace(/(?:\r\n|\r|\n)/g, '<br />')"></span>
        <br/>
      </vs-popup>
  </div>
</template>

<script>
window.axios = require('axios');
let sanitizeHtml = require('sanitize-html');

import EmailSidebar from "./EmailSidebar.vue"
import moduleSystem from "@/store/system/moduleSystem.js"

export default {
  components: {
    EmailSidebar
  },
  data() {
    return {
      clickNotClose        : true,
      isEmailSidebarActive : true,

      mailBody: "",
      mailTitle: "",
      notiEmailPopupActive: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      // Table
      columns: ['seq', 'sendStatus', 'sendScheduledDate', 'sendTarget', 'mailTitle', 'mailBody', 'sendStartDateTime',  'sendEndDateTime', 'sendResult', 'sendCount', 'edit' ],
      userColumns:  ['seq', 'sendStatus', 'sendScheduledDate', 'sendTarget', 'mailTitle', 'mailBody', 'sendStartDateTime',  'sendEndDateTime', 'sendResult', 'sendCount'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['sendStatus', 'sendScheduledDate', 'sendTarget',  'mailTitle', 'sendStartDateTime', 'sendEndDateTime', 'sendResult', 'sendCount'],
        sortable: ['seq', 'sendStatus', 'sendScheduledDate', 'sendTarget', 'mailTitle', 'sendStartDateTime',  'sendEndDateTime', 'sendResult', 'sendCount'],
        orderBy: { ascending: false },
        debounce: 1000,
        dateColumns:['sendScheduledDate', 'sendStartDateTime', 'sendEndDateTime'],
        dateFormat: 'YYYY-MM-DD',
        toMomentFormat: 'YYYYMMDD',
        datepickerOptions: {
            showDropdowns: true,
            autoUpdateInput: true
        },
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
            filterBy: this.$t("FILTER_BY"),
            defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'seq': () => this.$t("SEQ"),
          'sendStatus': () => this.$t("SEND_STATUS"),
          'sendScheduledDate': () => this.$t("SCHEDULED_DATE"),
          'sendTarget': () => this.$t("SEND_TARGET"),
          'mailTitle': () => this.$t("MAIL_TITLE"),
          'mailBody': () => this.$t("MAIL_BODY"),
          'sendStartDateTime': () => this.$t("SEND_START_DATETIME"), 
          'sendEndDateTime': () => this.$t("SEND_END_DATETIME"),
          'sendResult' : () => this.$t("SEND_RESULT"),
          'sendCount' : () => this.$t("SEND_COUNT"),
          'edit': () => this.$t("EDIT")
        },
        listColumns:{
           sendStatus:[
            {
              id: 1,
              text: this.$t("RESERVED")
            },
            {
              id: 2,
              text: this.$t("SENDING")
            },
            {
              id: 3,
              text: this.$t("SEND_COMPLETE")
            },
            {
              id: 4,
              text: this.$t("CANCEL_SEND")

            }
          ],
          sendTarget:[
            {
              id: 1,
              text: this.$t("ALL_MEMBER")
            },
            {
              id: 2,
              text: this.$t("MEMBER")
            },
             {
              id: 3,
              text: this.$t("NONMEMBER")
            }
          ],
          sendResult:[
            {
              id: 'S',
              text: this.$t("SUCCESS")
            },
            {
              id: 'E',
              text: this.$t("ERROR")
            }
          ],
        },
        requestAdapter: function(data) {

          if(data.query.sendScheduledDate){
            let start = moment(data.query.sendScheduledDate.start).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment(data.query.sendScheduledDate.end).utc().format('YYYY-MM-DD HH:mm:ss')

            data.query.sendScheduledDate.start = start
            data.query.sendScheduledDate.end = end
          }

          if(data.query.sendStartDateTime){
            let start = moment(data.query.sendStartDateTime.start).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment(data.query.sendStartDateTime.end).utc().format('YYYY-MM-DD HH:mm:ss')
                            
            data.query.sendStartDateTime.start = start
            data.query.sendStartDateTime.end = end
          }

          if(data.query.sendEndDateTime){
            let start = moment(data.query.sendEndDateTime.start).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment(data.query.sendEndDateTime.end).utc().format('YYYY-MM-DD HH:mm:ss')
                            
            data.query.sendEndDateTime.start = start
            data.query.sendEndDateTime.end = end
          }

          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "seq",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        requestFunction: function (data) {
          return this.$http.get('/api/noti-email-management/noti-email', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataSystem/SET_NOTI_EMAIL',response.data)
          return {
            data: this.$store.state.dataSystem.notiEmail,
            count: this.$store.state.dataSystem.notiEmailCount
          }
        },
        templates:{
          sendScheduledDate: function(h,row){
            let sendScheduledDate = row.sendScheduledDate
            if(!sendScheduledDate){
              return '-'
            }else {
              return this.$moment(sendScheduledDate,'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss')
            }
          },
          sendStartDateTime: function(h,row){
            let sendStartDateTime = row.sendStartDateTime
            if(!sendStartDateTime){
              return '-'
            }else {
              return this.$moment(sendStartDateTime,'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss')
            }
          },
          sendEndDateTime: function(h,row){
            let sendEndDateTime = row.sendEndDateTime
            if(!sendEndDateTime){
              return '-'
            }else {
              return this.$moment(sendEndDateTime,'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss')
            }
          },
        }
      }
    }
  },
  created() {
    if (!moduleSystem.isRegistered) {
      this.$store.registerModule('dataSystem', moduleSystem)
      moduleSystem.isRegistered = true
    }
  },
  computed:{
    onlyAdmin() {
      return this.$store.state.AppActiveUser.userRole === 'admin' ? this.$acl.check(this.$store.state.AppActiveUser.userRole) : false
    },
    getColumn(){
      if(this.$store.state.AppActiveUser.userRole === 'admin'){
        return this.columns
      }else{
        return this.userColumns
      }
    }
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getSendStatusColor(status) {
      if(status === "") return "primary"
      return this.$store.state.commonConfig.sendStatus.properties[status].color
    },
    setSendStatusName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.sendStatus.properties[status].name
    },
    getSendTargetColor(status) {
      if(status === "") return "danger"
      return this.$store.state.commonConfig.sendTarget.properties[status].color
    },
    setSendTargetName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.sendTarget.properties[status].name
    },
    getSendResultColor(status) {
      if(status === "") return "danger"
      return this.$store.state.commonConfig.sendResult.properties[status].color
    },
    setSendResultName(status){
      if(status === "") return ""
      return this.$store.state.commonConfig.sendResult.properties[status].name
    },
    notiEmailBodyPopup(data){
      this.notiEmailPopupActive = true;
      this.mailTitle = sanitizeHtml(data.mailTitle)
      this.mailBody = sanitizeHtml(data.mailBody)
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeMailViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isEmailSidebarActive = value
    },
    checkEdit(data){
      let mailStatus = data.sendStatus
      let scheduledDate = this.$moment(data.sendScheduledDate,'YYYYMMDDHHmmss').tz("Etc/UTC").format('x').valueOf()
      let today = this.$moment(new Date()).tz("Etc/UTC").format('x').valueOf()
      let scheduledDate1Hbefore = scheduledDate - 3600000

      if( mailStatus == 1  && scheduledDate1Hbefore > today ){
         this.editData(data)
      }else{
        this.errorAlert(this.$t("ERROR"),  this.$t('REFUSE_EDIT_MAIL'))
      }
    }
  },
}

</script>

<style lang="scss">

#notice-table{
  text-align:center;
}

.popupY {
  background:#EFEDFD;
  font-weight: bold;
}

// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 530px;
        // max-height: 95vh;

        .vs-dialog-text {
            padding: 0;

            .scroll-area {
                max-height: 75vh;
            }
        }
    }

    .con-img-upload {

    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }

    .quill-editor {
        margin-bottom: 1.5rem
    }

    .ql-editor {
        height: 150px;
    }
}

#send-count{
  text-align: center;
}


</style>